export const state = {
    type: null,
    message: null,
    nickname: '昵称啊',
    isOpenShare: false,
};

export const mutations = {
    success(state, message) {
        state.type = 'success';
        state.message = message;
    },
    error(state, message) {
        state.type = 'danger';
        state.message = message;
    },
    clear(state) {
        state.type = null;
        state.message = null;
    },
    setNickName(state,message){
        state.nickname = message;
    },
    // 保存是否打开分享
    saveIsOpenShare(state,isOpenShare){
        state.isOpenShare = isOpenShare;
    }
};

export const actions = {
    success({ commit }, message) {
        commit('success', message);
    },
    error({ commit }, message) {
        commit('error', message);
    },
    clear({ commit }) {
        commit('clear');
    },
    setNickName({ commit }, message) {
        commit('setNickName', message);
    },
    // 保存是否打开分享
    saveIsOpenShare({ commit }, message){
        commit('saveIsOpenShare', message);
    }
};
